export default "__VITE_PUBLIC_ASSET__5b85f7d7__"